const PbxxRecord = require('../../pbxx_record')

module.exports = class CampaignReportingRetailerShareSummary extends PbxxRecord {
  static get class_name() {
    return 'CampaignReportingRetailerShareSummary'
  }
}
